// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('resellerorder.resellerordersearch', {
        url: '/search',
        templateUrl: 'main/resellerorder/resellerordersearch/resellerordersearch.tpl.html',
        controller: 'ResellerOrderSearchController as vm',
        resolve: {
        },
        params: {
            searchTerm: ''
        }
    });
}

// @ngInject
function ResellerOrderSearchController($rootScope, $state, $translate) {
    var vm = this;

    //Properties
    vm.canAccess = $rootScope.canAccess;
    vm.showSearchFields = true;

    //Public methods
    vm.toggleSearchFields = toggleSearchFields;
    vm.getStatusTranslation = getStatusTranslation;
    vm.getOrderTypeTranslation = getOrderTypeTranslation;

    activate();

    function activate() {
        vm.showSearchFields = true;
    }

    function toggleSearchFields() {
        vm.showSearchFields = !vm.showSearchFields;
    }

    function getStatusTranslation(text) {
        var textCapital = text.substr(0, 1).toUpperCase() + text.substr(1, text.length - 1);
        return $translate.instant('resellerorder.status' + textCapital);
    }

    function getOrderTypeTranslation(text) {
        var textCapital = text.substr(0, 1).toUpperCase() + text.substr(1, text.length - 1);
        return $translate.instant('resellerorder.type' + textCapital);
    }
}

angular
    .module('resellerorder.resellerordersearch', [])
    .config(stateConfig)
    .controller('ResellerOrderSearchController', ResellerOrderSearchController);
